export default __webpack_public_path__ + "img/course-fingerfood.2b91aca38e10adf4c207221ac857d52a.png";